import React, { useState, useEffect, memo } from "react";
import { backend, API_URL } from "../../../config";
import {
  CircularProgress,
  Container,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Typography,
  Button,
  Link,
  Tooltip,
  IconButton,
  Stack,
  Modal,
  Grid,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600)]: {
      width: 900,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(5),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export const Overrides = (props) => {
  const classes = useStyles();

  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [products, setProducts] = useState([]);
  const [productsLoaded, setProductsLoaded] = useState(false);
  // const [resetModal, setResetModal] = useState(false);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [includeInactive, setIncludeInactive] = useState(false);
  const [includeNonprimary, setIncludeNonprimary] = useState(false);

  const handleChangeIncludeInactive = (e) => {
    const { checked } = e.target;

    setIncludeInactive(checked);
    setProductsLoaded(false);
  };

  const handleChangeIncludeNonprimary = (e) => {
    const { checked } = e.target;

    setIncludeNonprimary(checked);
    setProductsLoaded(false);
  };

  // const toggleResetModal = () => setResetModal(!resetModal);

  const resetModal = selectedItem !== null;

  const resolveRequest = () => {
    setLoadingFlag(false);
    setFinishedFlag(false);
    // toggleResetModal();
    setSelectedItem(null);
    setErrorInfo({ error: false, message: "" });
  };

  const sendRequest = async () => {
    setLoadingFlag(true);

    const productObj = {
      prime_price: null,
      case_discount_multiplier: null,
    };

    await backend
      .patch(
        `${API_URL}productedit/${selectedItem.upc}/resetoverride`,
        productObj
      )
      .then(({ data }) => {
        setProducts((prevState) =>
          prevState.map((item) => {
            if (item.upc !== selectedItem.upc) return item;

            console.log();

            return { ...item, reset_overrides: true };
          })
        );
        setFinishedFlag(true);
        setLoadingFlag(false);
      })
      .catch((error) => {
        console.log(error);
        setErrorInfo({
          error: true,
          message: JSON.stringify(error.response.data),
        });
      });

    resolveRequest();
  };

  const resetModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to reset
          <b>{` ${selectedItem?.name || selectedItem?.api_description} `}</b>
          overrrides?
          <div align="right">
            <Button onClick={() => resolveRequest()} className={classes.button}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              Reset overrides in progress
              <br />
              This may take some time relative to the number of overrides
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while resetting overrides
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "scroll",
                  display: "inline-block",
                  width: "100%",
                }}
              >
                <b>Error:</b>
                <br />
                <div dangerouslySetInnerHTML={{ __html: errorInfo.message }} />
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveRequest()}
                  className={classes.button}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The overrides reset was successful.
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
              className={classes.button}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  useEffect(() => {
    const getProducts = async () => {
      let urlParam = "no_page=1&has_price_override=1";

      urlParam =
        urlParam +
        `${urlParam === "" ? "" : "&"}include_inactive=${includeInactive}`;

      urlParam =
        urlParam +
        `${urlParam === "" ? "" : "&"}include_nonprimary=${includeNonprimary}`;

      return await backend
        .get(`${API_URL}products?${urlParam}`)
        .then(({ data }) => {
          const dataMap = data.map((item) => ({
            ...item,
            reset_overrides: false,
            unit_has_override: item.prime_price_override !== null,
            case_has_override: item.case_discount_multiplier_override !== null,
          }));

          setProducts(dataMap);
          setProductsLoaded(true);
        });
    };

    if (!productsLoaded) {
      getProducts();
    }
  }, [productsLoaded, includeInactive, includeNonprimary]);

  return (
    <Container>
      <Modal open={resetModal} onClose={resolveRequest}>
        {resetModalContent}
      </Modal>
      {!productsLoaded && (
        <div align="center">
          <br />
          <CircularProgress />
          <div>
            Loading products <br />
          </div>
        </div>
      )}
      {productsLoaded && !products.length && (
        <div align="center">
          <br />
          <InfoOutlinedIcon fontSize="large" />
          <div>
            There are no products with overrides to display. <br />
          </div>
        </div>
      )}
      {!errorInfo.error && productsLoaded && products.length ? (
        <>
          <Grid container spacing={2}>
            <Grid item xs={true}>
              <Typography component="h6" variant="h6">
                {`Products with overrides`}
              </Typography>
            </Grid>
            <Grid item xs={"auto"}>
              <FormControlLabel
                value="start"
                control={
                  <Checkbox
                    name="include_inactive"
                    value={includeInactive}
                    checked={includeInactive}
                    onChange={handleChangeIncludeInactive}
                    color="primary"
                  />
                }
                label="Show Inactive"
                labelPlacement="end"
              />
              <FormControlLabel
                value="start"
                control={
                  <Checkbox
                    name="include_nonprimary"
                    value={includeNonprimary}
                    checked={includeNonprimary}
                    onChange={handleChangeIncludeNonprimary}
                    color="primary"
                  />
                }
                label="Show Non Primary"
                labelPlacement="end"
              />
            </Grid>
          </Grid>
          <TableComponent
            products={products}
            setSelectedItem={setSelectedItem}
          />
        </>
      ) : (
        <></>
      )}
    </Container>
  );
};

const TableComponent = memo(({ products, setSelectedItem }) => {
  return (
    <TableContainer style={{ maxHeight: "80vh" }}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell size="small">UPC</TableCell>
            <TableCell size="small">Description</TableCell>
            <TableCell size="small">Item Code</TableCell>
            <TableCell size="small">Unit Price</TableCell>
            <TableCell size="small">Case Price</TableCell>
            <TableCell size="small">Unit Price Override</TableCell>
            <TableCell size="small">Case Price Override</TableCell>
            <TableCell size="small">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map((item, index) => (
            <TableRowComponent
              key={index}
              item={item}
              setSelectedItem={setSelectedItem}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
});

const TableRowComponent = memo(({ item, index, setSelectedItem }) => {
  return (
    <TableRow
      key={`row-${index}`}
      hover
      tabIndex={-1}
      style={{ opacity: item.reset_overrides ? 0.5 : 1 }}
    >
      <TableCell size="small">{item.upc}</TableCell>
      <TableCell size="small">{item.name}</TableCell>
      <TableCell size="small" style={{ textAlign: "center" }}>
        {item.item_code?.item_code}
      </TableCell>
      <TableCell size="small" style={{ textAlign: "center" }}>
        {item.api_unit_price ? `$${item.api_unit_price}` : "N/A"}
      </TableCell>
      <TableCell size="small" style={{ textAlign: "center" }}>
        {item.api_case_price ? `$${item.api_case_price}` : "N/A"}
      </TableCell>
      <TableCell
        size="small"
        style={{
          background: item.unit_has_override ? "lightyellow" : "inerit",
          fontWeight: item.unit_has_override ? "bold" : "normal",
          textAlign: "center",
        }}
      >
        {item.display_unit_price ? `$${item.display_unit_price}` : "N/A"}
      </TableCell>
      <TableCell
        size="small"
        style={{
          background: item.case_has_override ? "lightyellow" : "inherit",
          fontWeight: item.case_has_override ? "bold" : "normal",
          textAlign: "center",
        }}
      >
        {item.display_case_price ? `$${item.display_case_price}` : "N/A"}
      </TableCell>
      <TableCell size="small">
        <Stack direction="row" spacing={1}>
          <Link href={`/product/${item.upc}`} target="_blank">
            <Tooltip title="Edit product">
              <IconButton aria-label="edit product">
                <OpenInNewIcon />
              </IconButton>
            </Tooltip>
          </Link>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => setSelectedItem(item)}
          >
            <Typography variant="subtitle2" className="text-white">
              Reset
            </Typography>
          </Button>
        </Stack>
      </TableCell>
    </TableRow>
  );
});

export default Overrides;
